import { Component, Inject } from '@angular/core';
import { FormsModule } from '@angular/forms';

import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { MatCheckbox } from '@angular/material/checkbox';

interface IRemoveDestinationData {
  cityName: string;
  minusDays: number;
  newEndDate: string;
  isOptimizedMode: boolean;
}

@Component({
  selector: 'remove-destination-dialog',
  templateUrl: './remove-destination-dialog.component.html',
  styleUrls: ['./remove-destination-dialog.component.scss'],
  imports: [MatCheckbox, FormsModule],
})
export class RemoveDestinationDialogComponent {
  maintainDuration: boolean = false;

  constructor(
    @Inject(MAT_DIALOG_DATA) public data: IRemoveDestinationData,
    private dialogRef: MatDialogRef<RemoveDestinationDialogComponent>,
  ) {}

  closeModal(body: { res: boolean; maintain: boolean }): void {
    this.dialogRef.close(body);
  }
}
